import React from "react";
import { connect } from "react-redux";
import CustomLabel from "../../sub/CustomLabel";
import Paginator from "../../sub/Paginator";
import { FormattedMessage, injectIntl } from "react-intl";
import { UncontrolledTooltip } from "reactstrap";
import Util from "../../../util/Util";
import ConfirmationModal from "../../sub/modals/ConfirmationModal";
import CompanyListingRow from "./CompanyListingRow";
import CompanyListingUserModal from "./CompanyListingUserModal";
import CompanyAddModal from "./../CompanyAdd/CompanyAddModal";
import NotificationModal from "../../sub/modals/NotificationModal";
import CompanyExportModal from "./CompanyExportModal";

class CompanyListing extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: null,
      nameFilter: "",
      urlFilter: "",
    };

    this.paginator = new Paginator(this);
  }

  closeModal() {
    this.setState({ modal: null });
  }

  updateChildState(data) {
    this.setState(data);
  }

  openConfModal(title, content, successCallback) {
    this.setState({
      modal: (
        <ConfirmationModal
          isOpen={true}
          size="md"
          title={title}
          content={content}
          successCallback={successCallback}
          closeModal={() => this.closeModal()}
        />
      ),
    });
  }

  openErrorModal(ModalTitle, ModalContent) {
    this.setState({
      modal: (
        <NotificationModal
          isOpen={true}
          title={ModalTitle}
          content={ModalContent}
          variant="danger"
          successCallback={() => true}
          closeModal={(e) => this.closeModal()}
        />
      ),
    });
  }

  openNotifModal(ModalTitle, ModalContent, successCallback) {
    this.setState({
      modal: (
        <NotificationModal
          isOpen={true}
          title={ModalTitle}
          content={ModalContent}
          variant="success"
          successCallback={() => true}
          closeModal={(e) => this.closeModal()}
        />
      ),
    });
  }

  openAddCompanyModal() {
    this.setState({
      modal: <CompanyAddModal close={() => this.closeModal()} />,
    });
  }

  openUsersModal(company) {
    this.setState({
      modal: (
        <CompanyListingUserModal
          company={company}
          close={() => this.closeModal()}
        />
      ),
    });
  }

  openEditModal(company) {
    this.setState({
      modal: (
        <CompanyAddModal company={company} close={() => this.closeModal()} />
      ),
    });
  }

  openExportModal(company) {
    this.setState({
      modal: (
        <CompanyExportModal company={company} close={() => this.closeModal()} />
      ),
    });
  }

  areResultsFiltered = () => {
    return (
      !Util.emptyString(this.state.nameFilter) ||
      !Util.emptyString(this.state.urlFilter)
    );
  };

  resetSearchFields() {
    this.setState({
      nameFilter: "",
      urlFilter: "",
    });
  }

  render() {
    this.paginator.init();
    let disableFormInput = this.paginator.paginationIndex !== 1 ? true : false;

    var companiesNodes =
      this.props.company !== undefined &&
      this.props.company.length > 0 &&
      this.props.company.map((company) => {
        if (this.state.nameFilter && this.state.nameFilter !== "") {
          if (
            company.name
              .toUpperCase()
              .indexOf(this.state.nameFilter.toUpperCase()) === -1
          )
            return null;
        }

        if (this.state.urlFilter && this.state.urlFilter !== "") {
          if (
            company.url
              .toLowerCase()
              .indexOf(this.state.urlFilter.toLowerCase()) === -1
          )
            return null;
        }

        if (!this.paginator.keep()) return null;

        return (
          <CompanyListingRow
            key={company._id}
            company={company}
            openErrorModal={(title, content) =>
              this.openErrorModal(title, content)
            }
            openNotifModal={(title, content, successCallback) =>
              this.openNotifModal(title, content, successCallback)
            }
            openConfModal={(title, content, successCallback) =>
              this.openConfModal(title, content, successCallback)
            }
            openExportModal={(company) => this.openExportModal(company)}
            openUsersModal={(company) => this.openUsersModal(company)}
            openEditModal={(company) => this.openEditModal(company)}
          />
        );
      });

    //******** RESET BUTTON  ************/
    let resetSearchButton = () => {
      let button = (
        <button className="btn btn-outline-secondary" disabled>
          <i className="fa fa-filter" />
        </button>
      );

      if (this.areResultsFiltered() && !disableFormInput) {
        return (
          <div>
            <button
              id="searchFilterBtn"
              className="btn btn-warning"
              onClick={() => this.resetSearchFields()}
            >
              <i className="fa fa-filter" />
            </button>
            <UncontrolledTooltip
              delay={{ show: 0, hide: 0 }}
              placement="bottom"
              target="searchFilterBtn"
            >
              <FormattedMessage id="Remove.Filter" />
            </UncontrolledTooltip>
          </div>
        );
      } else {
        return button;
      }
    };

    return (
      <React.Fragment>
        <div className="row search-filters">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <div className="form-inline">
                  <CustomLabel
                    label={this.props.intl.formatMessage({
                      id: "Name",
                    })}
                    htmlFor="search_company"
                    labelClassName="my-1 mr-2"
                  />
                  <input
                    id="search_company"
                    className="form-control mr-sm-3 ml-2"
                    type="search"
                    onChange={(e) => {
                      this.setState({ nameFilter: e.target.value });
                    }}
                    placeholder={this.props.intl.formatMessage({ id: "Name" })}
                    disabled={disableFormInput}
                    value={this.state.nameFilter}
                  />

                  <CustomLabel
                    label={this.props.intl.formatMessage({
                      id: "URL",
                    })}
                    htmlFor="search_company_url"
                    labelClassName="my-1 mr-2"
                  />
                  <input
                    id="search_company_url"
                    className="form-control mr-sm-3 ml-2"
                    type="search"
                    onChange={(e) => {
                      this.setState({ urlFilter: e.target.value });
                    }}
                    placeholder={this.props.intl.formatMessage({ id: "URL" })}
                    disabled={disableFormInput}
                    value={this.state.urlFilter}
                  />

                  {resetSearchButton()}
                  <button
                    className="btn btn-info ml-auto"
                    onClick={() => this.openAddCompanyModal()}
                  >
                    <FormattedMessage id="Menu.SuperAdmin.Add.Company" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <table className="table tablee4coll">
          <thead>
            <tr>
              <th scope="col">
                <FormattedMessage id="Name" />
              </th>
              <th scope="col">
                <FormattedMessage id="URL" />
              </th>
              <th scope="col">
                <FormattedMessage id="Creation.Date" />
              </th>
              <th scope="col">
                <FormattedMessage id="API" />
              </th>
              <th scope="col" className="align-middle text-center tdaction">
                <FormattedMessage id="Actions" />
              </th>
            </tr>
          </thead>
          <tbody>{companiesNodes}</tbody>
        </table>
        {this.paginator.render()}

        {this.state.modal}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    company: state.company,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    //
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(CompanyListing));
